const STORAGE_KEY = 'rowsprint:dice-effects:v1';

function systemPrefersReducedMotion() {
  return typeof window !== 'undefined'
    && typeof window.matchMedia === 'function'
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

export function loadDiceEffects() {
  const defaults = {
    sound: false,
    haptics: true,
    reducedMotion: systemPrefersReducedMotion()
  };

  if (typeof window === 'undefined') return defaults;

  try {
    const stored = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || 'null');
    if (!stored || typeof stored !== 'object') return defaults;
    return {
      sound: typeof stored.sound === 'boolean' ? stored.sound : defaults.sound,
      haptics: typeof stored.haptics === 'boolean' ? stored.haptics : defaults.haptics,
      reducedMotion: typeof stored.reducedMotion === 'boolean' ? stored.reducedMotion : defaults.reducedMotion
    };
  } catch {
    return defaults;
  }
}

export function saveDiceEffects(effects) {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify({
      sound: Boolean(effects.sound),
      haptics: Boolean(effects.haptics),
      reducedMotion: Boolean(effects.reducedMotion)
    }));
  } catch {
    // Private browsing and restricted storage should not block the game.
  }
}

let audioContext = null;

export async function playDiceRollSound() {
  if (typeof window === 'undefined') return false;
  const AudioContextClass = window.AudioContext || window.webkitAudioContext;
  if (!AudioContextClass) return false;

  try {
    audioContext ||= new AudioContextClass();
    if (audioContext.state === 'suspended') await audioContext.resume();

    const duration = 0.72;
    const sampleRate = audioContext.sampleRate;
    const frameCount = Math.floor(sampleRate * duration);
    const buffer = audioContext.createBuffer(1, frameCount, sampleRate);
    const samples = buffer.getChannelData(0);

    for (let index = 0; index < frameCount; index += 1) {
      const time = index / sampleRate;
      const envelope = Math.max(0, 1 - time / duration);
      const pulse = 0.42 + 0.58 * Math.abs(Math.sin(time * 95));
      samples[index] = (Math.random() * 2 - 1) * envelope * pulse * 0.34;
    }

    const source = audioContext.createBufferSource();
    const filter = audioContext.createBiquadFilter();
    const gain = audioContext.createGain();

    filter.type = 'bandpass';
    filter.frequency.setValueAtTime(720, audioContext.currentTime);
    filter.frequency.exponentialRampToValueAtTime(180, audioContext.currentTime + duration);
    filter.Q.value = 0.8;
    gain.gain.setValueAtTime(0.0001, audioContext.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.42, audioContext.currentTime + 0.025);
    gain.gain.exponentialRampToValueAtTime(0.0001, audioContext.currentTime + duration);

    source.buffer = buffer;
    source.connect(filter).connect(gain).connect(audioContext.destination);
    source.start();
    source.stop(audioContext.currentTime + duration);
    return true;
  } catch {
    return false;
  }
}

export function vibrateForRoll() {
  if (typeof navigator === 'undefined' || typeof navigator.vibrate !== 'function') return false;
  try {
    return navigator.vibrate([22, 32, 28, 38, 20]);
  } catch {
    return false;
  }
}
